import { render, staticRenderFns } from "./CartBlock.vue?vue&type=template&id=2846a7da&scoped=true&"
import script from "./CartBlock.vue?vue&type=script&lang=js&"
export * from "./CartBlock.vue?vue&type=script&lang=js&"
import style0 from "./CartBlock.vue?vue&type=style&index=0&id=2846a7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846a7da",
  null
  
)

export default component.exports